var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "wl-container" },
    [
      _c("NewComments", {
        attrs: { messageType: _vm.messageType, siteId: _vm.siteId },
      }),
      _c("div", { staticClass: "wl-content-container content-with-comments" }, [
        _c("div", { staticClass: "tab-row" }, [
          _vm.adminTabs.length > 0 && _vm.activeTab
            ? _c(
                "ul",
                { staticClass: "tab-cls" },
                _vm._l(_vm.adminTabs, function (item) {
                  return _c(
                    "li",
                    {
                      key: item.key,
                      class: _vm.activeTab.key === item.key ? "active" : "",
                      on: {
                        click: function ($event) {
                          return _vm.activeChange(item)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(item.name) +
                          "\n                "
                      ),
                    ]
                  )
                }),
                0
              )
            : _vm._e(),
          _c("div", { staticClass: "btn flex item-center" }, [
            _c(
              "span",
              {
                class: [
                  "clear-filter",
                  _vm.clearFilterActive ? "clear-filter-active" : "",
                ],
                on: { click: _vm.clearAll },
              },
              [
                _c("img", {
                  staticClass: "table-setting-icon",
                  attrs: { src: require("@/assets/img/icon-screen.svg") },
                }),
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("clear_filter")) +
                    "\n                "
                ),
              ]
            ),
          ]),
        ]),
        _vm.activeTab
          ? _c(
              "div",
              { staticClass: "main-content" },
              [
                _c(_vm.activeTab.comName, {
                  ref: "activeTab",
                  tag: "component",
                  attrs: { clearFilterActive: _vm.clearFilterActive },
                  on: {
                    "update:clearFilterActive": function ($event) {
                      _vm.clearFilterActive = $event
                    },
                    "update:clear-filter-active": function ($event) {
                      _vm.clearFilterActive = $event
                    },
                  },
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }